import createIcon from '../../createIcon';

/**
 * @component @name FileOpen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMzE0OSAxLjgyMDMxSDQuMzE0OTRDMy4yMTQ5NCAxLjgyMDMxIDIuMzE0OTQgMi43MjAzMSAyLjMxNDk0IDMuODIwMzFWMTkuODIwM0MyLjMxNDk0IDIwLjkyMDMgMy4yMDQ5NCAyMS44MjAzIDQuMzA0OTQgMjEuODIwM0gxMy4zMTQ5VjEzLjgyMDNIMTguMzE0OVY3LjgyMDMxTDEyLjMxNDkgMS44MjAzMVpNMTEuMzE0OSA4LjgyMDMxVjMuMzIwMzFMMTYuODE0OSA4LjgyMDMxSDExLjMxNDlaTTE1LjMxNDkgMjEuNDgwM1YxNS44MjAzSDIwLjk3NDlWMTcuODIwM0gxOC43MzQ5TDIxLjY4NDkgMjAuNzcwM0wyMC4yNzQ5IDIyLjE4MDNMMTcuMzE0OSAxOS4yMzAzVjIxLjQ3MDNIMTUuMzE0OVYyMS40ODAzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileOpen = createIcon('FileOpen', [
  [
    'path',
    {
      d: 'M12.3149 1.82031H4.31494C3.21494 1.82031 2.31494 2.72031 2.31494 3.82031V19.8203C2.31494 20.9203 3.20494 21.8203 4.30494 21.8203H13.3149V13.8203H18.3149V7.82031L12.3149 1.82031ZM11.3149 8.82031V3.32031L16.8149 8.82031H11.3149ZM15.3149 21.4803V15.8203H20.9749V17.8203H18.7349L21.6849 20.7703L20.2749 22.1803L17.3149 19.2303V21.4703H15.3149V21.4803Z',
      key: 'c87aaa',
    },
  ],
]);

export default FileOpen;
